<template>
  <modal @before-open="beforeOpen" @opened="opened" name="orderDetail" :clickToClose="true" :draggable="'.header'"
         :reset="true"
         :classes="['schedule','generalbox']"
         :adaptive="true"
          :height="'80%'" :width="'80%'" :max-width="1540" :min-width="1092" :min-height="614"
         :click-to-close="false">

    <div class="header">
      <h2>预约详情</h2>
      <div @click="close" class="close">
        <i class="iconfont icon-cha"></i>
      </div>
    </div>
    <div class="content">

      <div v-if="sort===4" class="manageView mainview">
        <h2>{{date}}预约详情</h2>
        <ul class="stateDesc">
          <li>
            <span class="no"></span>
            <p>不可预约</p>
          </li>
          <li>
            <span class="half"></span>
            <p>已经预约人数</p>
          </li>
          <li>
            <span class="full"></span>
            <p>已经处理人数</p>
          </li>
          <li>
            <span class="can"></span>
            <p>开放预约人数</p>
          </li>
        </ul>
        <h2 style="display: none" class="nodata">暂无数据</h2>


        <ul class="managerOrderViewList">
          <li>
            <div>服务名称</div>
            <div>上午</div>
            <div>下午</div>
            <div>晚上</div>
          </li>
          <li v-for="(item,index) in tableData">
            <div>{{item.sysname}}</div>
            <div @click="selectRow(index,item,{field:'morning'})">
              <progress-bar :progressBarData="item.morning.orderData"></progress-bar>
            </div>
            <div @click="selectRow(index,item,{field:'afternoon'})">
              <progress-bar :progressBarData="item.afternoon.orderData"></progress-bar>
            </div>
            <div @click="selectRow(index,item,{field:'evening'})">
              <progress-bar :progressBarData="item.evening.orderData"></progress-bar>
            </div>
          </li>

        </ul>
        <div v-if="false" class="tableContainer">
          <v-table
              :row-click-color="'rgba(239,239,239,0.5)'"
              :row-click="selectRow"
              style="width:100%"
              :is-horizontal-resize="true"
              :columns="columns"
              :table-data="tableData"
              :show-vertical-border="false"
              ref="tableOverview"
          ></v-table>
        </div>
      </div>
      <div v-if="sort===5" class="manageView mainview">
        <h2>{{date}}预约详情</h2>
        <h2 style="display: none" class="nodata">暂无数据</h2>
        <div class="tableContainer">
          <v-table
              :row-click-color="'rgba(239,239,239,0.5)'"
              :row-click="userSelectRow"
              style="width:100%"
              :is-horizontal-resize="true"
              :columns="userColumns"
              :table-data="userTableData"
              :show-vertical-border="false"
              ref="tableOverview"
          ></v-table>
        </div>
      </div>
      <order-user-list></order-user-list>
    </div>

  </modal>
</template>

<script>
  //通信总线
  import Bus from 'common/js/bus.js';
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  //预约的用户列表
  import orderUserList from 'components/order/orderUserListModal'

  import progressBar from 'components/order/progress'

  export default {
    name: "orderDetail",
    data() {
      return {
        date: null,
        info: null,
        sort: null,
        columns: [
          {
            field: 'sysname', title: '服务名称', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              return `<span class='toServiceHandle'>${rowData[field]}</span>`
            }
          },
          {
            field: 'morning', title: '上午', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              return this.getDomStrByStatus(rowData.morning)
            }
          },
          {
            field: 'afternoon', title: '下午', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              return this.getDomStrByStatus(rowData.afternoon)
            }
          },
          {
            field: 'evening', title: '晚上', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              return this.getDomStrByStatus(rowData.evening)
            }
          },
        ],
        tableData: [],
        userColumns: [
          {
            field: 'sysname', title: '服务名称', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              return `<span class='toServiceHandle'>${rowData[field]}</span>`
            }
          },
          {
            field: 'date', title: '预约日期', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          },
          {
            field: 'step', title: '预约时段', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          },
          {
            field: 'username', title: '联系人', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          },
          {
            field: 'tel', title: '联系方式', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          },
          {
            field: 'address', title: '办理地点', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          },
          {
            field: 'status', title: '当前状态', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          },
          {
            field: 'time', title: '处理时间', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          },

        ],
        userTableData: []
      }
    },
    computed: {},
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("orderDetail");
      },
      initData() {
        this.tableData = []
        this.userTableData = []
      },

      async beforeOpen(data) {
        this.initData()
        this.date = this.convertDateToLong(data.params.date);
        this.info = data.params.info;
        this.sort = data.params.info.sort;

        if (this.sort === 4) {
          //管理员视图
          this.initManageView();
        } else {
          //用户视图
          this.initUserView();
        }
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      //初始化管理员视图
      async initManageView() {
        this.tableData = []

        let orderInfo = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getScheduleInfo?' + this.$qs.stringify({
          day: this.date,
          sort: this.sort
        }));
        orderInfo = orderInfo.data.data;
        orderInfo.forEach((item, index) => {
          if(!item.appEntity){
            return
          }
          let rowData = {
            sysname: item.appEntity.name,
            sysId: item.appid,
            guideId: item.appEntity.guideId,
            morning: this.getOrderStepStatusByType(item.oelist, 0),
            afternoon: this.getOrderStepStatusByType(item.oelist, 1),
            evening: this.getOrderStepStatusByType(item.oelist, 2),
          }
          this.tableData.push(rowData)
        })
      },
      //初始化用户端视图
      async initUserView() {

        let orderInfo = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getScheduleInfo?' + this.$qs.stringify({
          day: this.date,
          sort: this.sort
        }));
        orderInfo = orderInfo.data.data;
        orderInfo.forEach((item, index) => {
          let rowData = {
            sysname: item.appEntity.name,
            sysId: item.appid,
            guideId: item.appEntity.guideId,
            date: item.day,
            step: this.getOrderStepDesc(item),
            username: item.appOrder.username,
            address: item.appOrder.address,
            tel: item.appOrder.tel,
            status: this.getOrderDealStatusDesc(item.stauts),
            time: item.endtime
          }
          this.userTableData.push(rowData)

        })
      },
      getOrderStepStatusByType(data, type) {
        if (!data.length) return {status: 0, orderData: {}};
        let status = 0;
        let orderData;
        data.forEach((item, index) => {
          if (item.type === type) {
            status = item.status
            orderData = item;
          }
        })
        return {status, orderData}
      },

      getOrderStepDesc(data) {
        if (data['morning']) return '上午'
        if (data['afternoon']) return '下午'
        if (data['evening']) return '晚上'
        return '当前日期没有预约'
      },
      selectRow(rowIndex, rowData, column) {
        if (rowData[column.field].status === 0) {
          return;
        }
        if (column.field === 'address' || column.field === 'linkway') {
          return;
        }

        let type = this.getTypeByStepDesc(column.field);
        let descJson = {};
        descJson[column.field] = 1;
        let typeDesc = this.getOrderStepDesc(descJson)
        let sysId = rowData['sysId'];
        let day = this.date;
        let sysName = rowData['sysname'];
        let guideId = rowData['guideId'];
        if (column.field === 'sysname') {
          //打开应用指南
          this.$modal.show("serviceHandle", {guideId: guideId, appid: sysId, targetTab: 0});
        } else {
          //打开人员列表
          this.$modal.show('orderUserList', {sysId, type, day, sysName, guideId, typeDesc})
        }
      },
      //用户选择行
      userSelectRow(rowIndex, rowData, column) {
        let guideId = rowData['guideId']
        let sysId = rowData['sysId']
        if (column.field === 'sysname') {
          //打开应用指南
          this.$modal.show("serviceHandle", {guideId: guideId, appid: sysId, targetTab: 0});
        }
      },

      //通过时段描述获取类型ID
      getTypeByStepDesc(desc) {
        switch (desc) {
          case 'morning':
            return 0
          case 'afternoon':
            return 1
          case 'evening':
            return 2
          default:
            return 3
        }
      },
      getDomStrByStatus(data) {
        let status = data.status;
        let orderData = data.orderData;
        if (status === 0) {
          orderData.holdCount = "";
        }
        let className = '';
        let descrip = '';

        switch (status) {
          case 0:
            className = 'no';
            descrip = '不可预约';
            break;
          case 1:
            className = 'full';
            descrip = '预约已满';
            break;
          case 2:
            className = 'can';
            descrip = '可预约';
            break;
          case 3:
            className = 'half';
            descrip = '预约过半';
            break;
          case 4:
            className = 'ordered';
            descrip = '经预约';
            break;
          default:
            console.log('getDomStrByStatus参数异常');
        }
        return `<span title="${descrip}" class="orderStatus ${className}">${orderData.holdCount}</span>`
      },
      //补零
      padLeftZero: (str) => {
        str = str.toString();
        return ('00' + str).substr(str.length);
      },
      //转为长日期
      convertDateToLong(dateStr) {
        let dateArr = dateStr.split("-");
        dateArr.forEach((item, index) => {
          if (index === 0) {
            return;
          }
          dateArr[index] = this.padLeftZero(item);
        });
        dateStr = dateArr.join("-");
        return dateStr;
      },
      //获取状态描述
      getOrderDealStatusDesc(val) {
        switch (val) {
          case 0:
            return '已预约'
          case 1:
            return '已办理'
          case 2:
            return '已爽约'
          default:
            return '其他状态:' + val
        }
      }
    },
    mounted() {
      Bus.$on('updateUserInfo', () => {
        this.initManageView()
      })
    },
    components: {
      orderUserList,
      progressBar
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"

  .content

    h2
      font-size 16px
      color #333333
      text-align center
      line-height 60px

    h2.nodata
      font-size 14px
      color #666666

    .manageView
      .stateDesc
        margin-bottom 20px
        text-align center

        li
          display inline-block
          position relative
          padding-left 30px
          margin-right 10px
          font-size 14px
          color #666666

          span
            content ""
            left 0
            top 0
            bottom 0
            margin auto
            display inline-block
            width 20px
            height 20px
            position absolute

            &.no
              background-color #e6e6e6
              cursor not-allowed

            &.full
              background-color #16a61e
              cursor pointer

            &.can
              background-color #d2e9ff
              cursor pointer

            &.half
              background-color #004a94
              cursor pointer

            &.ordered::after
              background-color #16a61e
              cursor pointer

      .managerOrderViewList
        font-size 0

        li
          line-height 30px
          text-align center
          font-size 0
          margin-bottom 10px
          border-bottom 1px solid #eeeeee

          & > div
            padding 0 20px
            font-size 14px
            width 22%
            display inline-block

    .tableContainer
      & >>> .v-table-body-cell
        position relative

      & >>> .toServiceHandle
        color #004a94
        text-decoration underline
        transition 300ms
        cursor pointer

        &:hover
          color #006dcb

      & >>> .orderStatus
        /*float left*/
        background-color #ffffff
        border 1px solid #e6e6e6
        border-bottom none
        content ""
        left 0
        right 0
        top 0
        bottom 0
        margin auto
        display inline-block
        width 20px
        height 20px
        line-height 20px
        color #ffffff
        position absolute

        &.no
          background-color #e6e6e6
          cursor not-allowed

        &.full
          background-color #f96262
          cursor pointer

        &.can
          background-color #299bdf
          cursor pointer

        &.half
          background-color #ffd700
          cursor pointer

        &.ordered
          background-color #16a61e
          cursor pointer


        .iconfont
          position relative
          color #ffffff
          display block
          font-size 16px
          z-index 9
</style>



// WEBPACK FOOTER //
// src/components/order/orderDetailModal.vue